import React, { useState, useEffect } from 'react';
import ShareFile from './shareFileModal';
import { Modal, Button } from 'react-bootstrap';
import documentService from '../services/document';
import { toast } from 'react-toastify';
import { stateToHTML } from "draft-js-export-html";
import { convertFromRaw } from "draft-js";
import { asBlob } from 'html-docx-js-typescript'
import { saveAs } from "file-saver";
import adminServices from '../services/adminServices';
import Loader from '../utils/loader';
import html2pdf from 'html2pdf.js';
import { get } from 'lodash';
import { getBlogById, getAllUsersBlogs } from '../services/blogServices';
import { addUserLogs } from '../services/userLogServices';
import { Dialog, DialogContent, DialogActions, Button as MuiButton, Box, Typography, Slide } from '@material-ui/core';
import { Delete as DeleteIcon, WarningRounded as WarningIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      boxShadow: '0 15px 50px rgba(0, 0, 0, 0.18)',
      maxWidth: '420px',
      width: '100%',
    },
  },
  dialogTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#2c3e50',
    paddingBottom: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  dialogText: {
    fontSize: '0.95rem',
    color: '#555555',
    lineHeight: 1.6,
    fontWeight: 400,
  },
  iconWrapper: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  warningIcon: {
    fontSize: 64,
    color: '#ff6b6b',
  },
  deleteIcon: {
    fontSize: 64,
    color: '#ff4757',
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    borderTop: '1px solid #ecf0f1',
  },
  cancelBtn: {
    textTransform: 'none',
    fontSize: '0.95rem',
    fontWeight: 600,
    flex: 1,
    '&:hover': {
      backgroundColor: 'rgba(244, 67, 54, 0.08)',
    },
  },
  confirmBtn: {
    textTransform: 'none',
    fontSize: '0.95rem',
    fontWeight: 600,
    flex: 1,
  },
}));


////         Share Functionality   ////////////////////////////

export const ShareOptionModal = ({ show, onHide, id, setMyDocs }) => {
    const [documentData, setDocumentData] = useState(null);
    const [allDocumentData, setAllDocumentData] = useState([])
    const [loadingShareData, setLoadingShareData] = useState(false);
    // const [shareFileKey, setShareFileKey] = useState(0);


    const getDocsById = async () => {
        try {
            setLoadingShareData(true);
            const response = await documentService.getDocumentbyId(id);
            if (response.status === 200) {
                // Store the data in the state variable
                console.log("setDocumentData:",response.data.document)
                setDocumentData(response.data.document);

            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        } finally {
            setLoadingShareData(false);
        }
    };

    const getDocs = async () => {
        try {
            const response = await documentService.getAllDocuments();

            if (response.status === 200) {
                setAllDocumentData(response.data);
                //setDocuments(response.data);
                setMyDocs(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };


    useEffect(() => {
        console.log("id__", id)
        if (show && id) {
            setDocumentData(null);
            getDocsById();
            getDocs()
        }
    }, [id, show]);

    return (
        <>
            <Modal show={show} onHide={onHide} centered size="lg" id="shareOptionModal" style={{ marginTop: '30px' }}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Share Options
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ minHeight: "460px" }}>
                    <div className="container-fluid">
                        {/* Access ShareFile component here */}
                        {documentData !== null && <ShareFile
                            // key={shareFileKey}
                            shareDocumentId={documentData}
                            getDocuments={getDocs}
                            closeModal={onHide}
                            refreshDocument={getDocsById}
                        />}
                        {documentData === null && loadingShareData && (
                            <div style={{ minHeight: "360px", display: "flex", alignItems: "center", justifyContent: "center", color: "#6b7280" }}>
                                Loading share options...
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export const ShareOptionModal2 = ({ show, onHide, id}) => {
    const [documentData, setDocumentData] = useState(null);
    const [allDocumentData, setAllDocumentData] = useState([])
    const [loadingShareData, setLoadingShareData] = useState(false);
    // const [shareFileKey, setShareFileKey] = useState(0);


    const getDocsById = async () => {
        try {
            setLoadingShareData(true);
            const response = await getBlogById(id);
            if (response.status === 200) {
                // Store the data in the state variable
                console.log("setDocumentData:",response.data)
                setDocumentData(response.data);

            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        } finally {
            setLoadingShareData(false);
        }
    };

    const getDocs = async () => {
        try {
            const response = await getAllUsersBlogs(5,0,"all");

            if (response.status === 200) {
                setAllDocumentData(response.data);
                //setDocuments(response.data);
                //setMyDocs(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };


    useEffect(() => {
        console.log("id__", id)
        if (show && id) {
            setDocumentData(null);
            getDocsById();
            getDocs()
        }
    }, [id, show]);

    return (
        <>
            <Modal show={show} onHide={onHide} centered size="lg" id="shareOptionModal" style={{ marginTop: '30px' }}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Share Options
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ minHeight: "460px" }}>
                    <div className="container-fluid">
                        {/* Access ShareFile component here */}
                        {documentData !== null && <ShareFile
                            // key={shareFileKey}
                            shareDocumentId={documentData}
                            getDocuments={getDocs}
                            closeModal={onHide}
                        />}
                        {documentData === null && loadingShareData && (
                            <div style={{ minHeight: "360px", display: "flex", alignItems: "center", justifyContent: "center", color: "#6b7280" }}>
                                Loading share options...
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

///////////////   Delete Document Functionality    /////////////////////////////////////////

// export const DeleteOptionModal = ({ show, onHide, id, getAllDocuments }) => {
//     const classes = useStyles();
//     const [documentData, setDocumentData] = useState(null);
//     const [loading, setLoading] = useState(false);
    
//     const getDocsById = async () => {
//         try {
//             setLoading(true)
//             const response = await documentService.getDocumentbyId(id);
//             if (response.status === 200) {
//                 setDocumentData(response.data);
//                 setLoading(false)
//             } else {
//                 setLoading(false)
//                 console.error("Error fetching data:", response.message);
//             }
//         } catch (error) {
//             setLoading(false)
//             console.error("Error calling backend API:", error.message);
//         }
//     };

//     useEffect(() => {
//         if (id && show) {
//             getDocsById();
//         }
//     }, [id, show]);

//     const handleDelete = async () => {
//         try {
//             const data = await documentService.getDocumentbyId(documentData.document._id);
//             if (data.status === 200) {
//                 if (data.data.document.activeDoc === true) {
//                     if (documentData.document.status === "draft") {
//                         if (documentData.document.reviewStatus === true) {
//                             const og = await documentService.getDocumentbyId(documentData.document.orginalDocumentID);
//                             if (og.status === 200) {
//                                 if (og.data.pendingDocuments.includes(documentData.document._id)) {
//                                     toast.warn("Document is in Merging process");
//                                     return;
//                                 }
//                             }
//                         }
//                     }
//                     const res = await documentService.deleteDocuments(documentData?.document?._id);
//                     if (res.status === 200) {
//                         toast.success("Document deleted!");
//                         const logData = {
//                             userId:sessionStorage.getItem("userId"),
//                             organizationId:sessionStorage.getItem("organizationId"),
//                             actionType:"deleteDoc"
//                         }
//                         const addLogs = await addUserLogs(logData)
//                         if (addLogs.status !== 200) {
//                             toast.error(addLogs.message)
//                         }
//                         getAllDocuments();
//                         onHide();
//                     } else {
//                         toast.error("Oops..Something went wrong!!");
//                     }
//                 } else {
//                     toast.error("Error deleting document:");
//                 }
//             } else {
//                 toast.error("Error fetching document information");
//             }
//         } catch (error) {
//             console.error("Error deleting document:", error.message);
//             toast.error("Oops..Something went wrong!!");
//         }
//     };

//     return (
//         <>
//             <Loader loading={loading} />
//             <Dialog
//                 open={show}
//                 TransitionComponent={Transition}
//                 keepMounted
//                 onClose={onHide}
//                 className={classes.dialog}
//             >
//                 <DialogContent className={classes.dialogContent}>
//                     <Box className={classes.iconWrapper}>
//                         <DeleteIcon className={classes.deleteIcon} />
//                     </Box>
//                     <Typography className={classes.dialogTitle}>
//                         Delete Document
//                     </Typography>
//                     <Typography className={classes.dialogText}>
//                         Are you sure you want to delete this document? It will be moved to trash.
//                     </Typography>
//                 </DialogContent>
//                 <DialogActions className={classes.actionButtons}>
//                     <MuiButton 
//                         onClick={onHide}
//                         color='error' 
//                         variant='outlined'
//                         className={classes.cancelBtn}
//                     >
//                         Cancel
//                     </MuiButton>
//                     <MuiButton 
//                         onClick={handleDelete}
//                         color='primary' 
//                         variant='contained'
//                         className={classes.confirmBtn}
//                     >
//                         Delete
//                     </MuiButton>
//                 </DialogActions>
//             </Dialog>
//         </>
//     );
// };


export const DeleteOptionModal = ({ show, onHide, id, getAllDocuments }) => {
  const [documentData, setDocumentData] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const getDocsById = async () => {
    try {
      const response = await documentService.getDocumentbyId(id);

      if (response.status === 200) {
        setDocumentData(response.data.document);
      } else {
        toast.error("Failed to fetch document");
      }
    } catch (error) {
      console.error("Error fetching document:", error.message);
      toast.error("Error fetching document");
    }
  };

  useEffect(() => {
    if (id && show) {
      getDocsById();
    }
  }, [id, show]);

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const data = await documentService.getDocumentbyId(id);

      if (data.status === 200) {
        if (data.data.document.activeDoc === true) {
          const res = await documentService.deleteDocuments(id);

          if (res.status === 200) {
            toast.success("Document moved to trash");
            getAllDocuments();
            onHide();
          } else {
            toast.error("Something went wrong");
          }
        } else {
          toast.error("Document already deleted");
        }
      } else {
        toast.error("Failed to fetch document");
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      toast.error("Error deleting document");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogContent style={{ padding: "24px" }}>
        
        {/* Title */}
        <Typography
          style={{
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "10px",
          }}
        >
          Delete document?
        </Typography>

        {/* Description */}
        <Typography
          style={{
            fontSize: "14px",
            color: "#666",
            lineHeight: "1.5",
          }}
        >
          This document will be moved to trash.
          You can restore it later if needed.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions
        style={{
          padding: "16px 24px",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <MuiButton
          onClick={onHide}
          variant="text"
          style={{
            textTransform: "none",
            color: "#555",
          }}
        >
          Cancel
        </MuiButton>

        <MuiButton
          onClick={handleDelete}
          disabled={deleting}
          variant="contained"
          style={{
            textTransform: "none",
            backgroundColor: "#d32f2f",
            color: "#fff",
          }}
        >
          {deleting ? "Deleting..." : "Delete"}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};


///////////////   Delete Folder Functionality    /////////////////////////////////////////

export const DeleteFolderOptionModal = ({ show, onHide, id, getAllDocuments }) => {
    const classes = useStyles();
    const [documentData, setDocumentData] = useState(null);

    const getFolderById = async () => {
        try {
            const response = await documentService.getFolderbyId(id);
            if (response.status === 200) {
                setDocumentData(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
        if (id && show) {
            getFolderById();
        }
    }, [id, show]);

    const handleDelete = async () => {
        try {
            const res = await documentService.deleteFolder(documentData._id);
            if (res.status === 200) {
                toast.success("Folder deleted!");
                getAllDocuments();
                onHide();
            } else {
                toast.error("Oops.. Something went wrong!!");
            }
        } catch (error) {
            console.error("Error deleting folder:", error.message);
            toast.error("Oops.. Something went wrong!!");
        }
    };

    return (
        <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            onClose={onHide}
            className={classes.dialog}
        >
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.iconWrapper}>
                    <DeleteIcon className={classes.deleteIcon} />
                </Box>
                <Typography className={classes.dialogTitle}>
                    Delete Folder
                </Typography>
                <Typography className={classes.dialogText}>
                    Are you sure you want to delete this folder? It will be moved to trash.
                </Typography>
            </DialogContent>
            <DialogActions className={classes.actionButtons}>
                <MuiButton 
                    onClick={onHide}
                    color='error' 
                    variant='outlined'
                    className={classes.cancelBtn}
                >
                    Cancel
                </MuiButton>
                <MuiButton 
                    onClick={handleDelete}
                    color='primary' 
                    variant='contained'
                    className={classes.confirmBtn}
                >
                    Delete
                </MuiButton>
            </DialogActions>
        </Dialog>
    );
};


//////////////     Restore Document Functionality           /////////////////////////////////////

export const RestoreOptionModal = ({ show, onHide, id, getAllDocuments }) => {
    const [documentData, setDocumentData] = useState(null);

    const getDocsById = async () => {
        try {
            const response = await documentService.getDocumentbyId(id);
            if (response.status === 200) {
                setDocumentData(response.data.document);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
        // Fetch data when the component mounts or 'id' changes
        if (id) {
            getDocsById();
        }
    }, [id]);

    const handleRestore = async () => {
        try {
            const data = await documentService.getDocumentbyId(documentData._id);

            if (data.status === 200) {
                if (data.data.document.activeDoc === false) {
                    const res = await documentService.restoreDocuments(documentData._id);

                    if (res.status === 200) {
                        toast.success("Document restored!");
                        onHide(); // Close the modal after restoration
                        getAllDocuments();
                        const data = {
                            userId: sessionStorage.getItem("userId"),
                            organizationId: sessionStorage.getItem("organizationId"),
                            actionType: "restoreDoc",
                          };
                  
                        const addLogs = await addUserLogs(data);
                        if (addLogs.status !== 200) {
                            toast.error(addLogs.message);
                        }

                    } else {
                        toast.error("Oops..Something went wrong!!");
                    }
                } else {
                    alert("Document is not deleted");
                    onHide(); // Close the modal
                }
            } else {
                alert("Error fetching document information");
            }
        } catch (error) {
            console.error("Error restoring document:", error.message);
            toast.error("Oops..Something went wrong!!");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered id="restoreOptionModal">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Restore Document
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to restore the document?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="success" onClick={handleRestore}>
                    Restore
                </Button>
            </Modal.Footer>
        </Modal>
    );
};


//////////////     Restore Folder Functionality           /////////////////////////////////////

export const RestoreFolderOptionModal = ({ show, onHide, id, getAllDocuments }) => {
    const [documentData, setDocumentData] = useState(null);

    const getFolderById = async () => {
        try {
            const response = await documentService.getFolderbyId(id);
            if (response.status === 200) {
                setDocumentData(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
        // Fetch data when the component mounts or 'id' changes
        if (id) {
            getFolderById();
        }
    }, [id]);

    const handleRestore = async () => {
        try {
            const data = await documentService.getFolderbyId(documentData._id);

            console.log(data,"restore data folder")

            if (data.status === 200) {
                if (data.data.activeFolder === false) {
                    const res = await documentService.restoreFolder(documentData._id);

                    if (res.status === 200) {
                        toast.success("Folder restored!");
                        onHide(); // Close the modal after restoration
                        getAllDocuments();
                        const data={
                            userId:sessionStorage.getItem("userId"),
                            organizationId:sessionStorage.getItem("organizationId"),
                            actionType:"restoreFolder"
                          }
                          const addLogs = await addUserLogs(data)
                          if (addLogs.status !== 200) {
                              toast.error(addLogs.message)
                            }
                    } else {
                        toast.error("Oops..Something went wrong!!");
                    }
                } else {
                     toast.error("Folder is not deleted");
                    onHide(); // Close the modal
                }
            } else {
                 toast.error("Error fetching document information");
            }
        } catch (error) {
            console.error("Error restoring document:", error.message);
            toast.error("Oops..Something went wrong!!");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered id="restoreOptionModal">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Restore Folder
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to restore this folder?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="success" onClick={handleRestore}>
                    Restore
                </Button>
            </Modal.Footer>
        </Modal>
    );
};



/////////////////////  Individual Document - Delete Permanently  Functionality         ///////////////////////////////////

export const PermanentDeleteOptionModal = ({ show, onHide, id, getAllDocuments }) => {
    const classes = useStyles();
    const [documentData, setDocumentData] = useState(null);

    const getDocsById = async () => {
        try {
            const response = await documentService.getDocumentbyId(id);
            if (response.status === 200) {
                setDocumentData(response.data.document);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
        if (id && show) {
            getDocsById();
        }
    }, [id, show]);

    const handlePermanentDelete = async () => {
        try {
            const data = await documentService.getDocumentbyId(documentData._id);
            if (data.status === 200) {
                if (data.data.document.activeDoc === false) {
                    const res = await documentService.permanentDelete({
                        _id: documentData._id,
                        drafts: documentData.drafts,
                        status: documentData.status,
                        orginalDocumentID: documentData.orginalDocumentID,
                        editor: documentData.editor,
                        pendingDocuments: documentData.pendingDocuments,
                        mergeDocuments: documentData.mergeDocuments,
                    });
                    if (res.status === 200) {
                        toast.success("Document deleted permanently!");
                        const logData = {
                            userId:sessionStorage.getItem("userId"),
                            organizationId:sessionStorage.getItem("organizationId"),
                            actionType:"deleteDocPermanent"
                        }
                        const addLogs = await addUserLogs(logData)
                        if (addLogs.status !== 200) {
                            toast.error(addLogs.message)
                        }
                        getAllDocuments();
                        onHide();
                    } else {
                        toast.error("Oops..Something went wrong!!");
                    }
                } else {
                    toast.error("Document is not in trash");
                }
            } else {
                toast.error("Error fetching document information");
            }
        } catch (error) {
            console.error("Error permanently deleting document:", error.message);
            toast.error("Oops..Something went wrong!!");
        }
    };

    return (
        <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            onClose={onHide}
            className={classes.dialog}
        >
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.iconWrapper}>
                    <WarningIcon className={classes.warningIcon} />
                </Box>
                <Typography className={classes.dialogTitle}>
                    Delete Permanently?
                </Typography>
                <Typography className={classes.dialogText}>
                    This action cannot be undone. The document will be permanently deleted from your account.
                </Typography>
            </DialogContent>
            <DialogActions className={classes.actionButtons}>
                <MuiButton 
                    onClick={onHide}
                    color='primary' 
                    variant='outlined'
                    className={classes.cancelBtn}
                >
                    Cancel
                </MuiButton>
                <MuiButton 
                    onClick={handlePermanentDelete}
                    color='error' 
                    variant='contained'
                    className={classes.confirmBtn}
                >
                    Delete Permanently
                </MuiButton>
            </DialogActions>
        </Dialog>
    );
};


/////////////////////  Individual Folder - Delete Permanently  Functionality         ///////////////////////////////////


export const PermanentDeleteFolderOptionModal = ({ show, onHide, id, getAllDocuments }) => {
    const classes = useStyles();
    const [documentData, setDocumentData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getFolderById = async () => {
        try {
            setLoading(true)
            const response = await documentService.getFolderbyId(id);
            if (response.status === 200) {
                setDocumentData(response.data);
                setLoading(false)
            } else {
                console.error("Error fetching data:", response.message);
                setLoading(false)
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
            setLoading(false)
        }
    };

    useEffect(() => {
        if (id && show) {
            getFolderById();
        }
    }, [id, show]);

    const handlePermanentDelete = async () => {
        try {
            const data = await documentService.getFolderbyId(documentData._id);
            if (data.status === 200) {
                if (data.data.activeFolder === false) {
                    const res = await documentService.permanentDeleteFolder(documentData._id);
                    if (res.status === 200) {
                        toast.success("Folder deleted permanently!");
                        const logData = {
                            userId:sessionStorage.getItem("userId"),
                            organizationId:sessionStorage.getItem("organizationId"),
                            actionType:"deleteFolderPermanent"
                        }
                        const addLogs = await addUserLogs(logData)
                        if (addLogs.status !== 200) {
                            toast.error(addLogs.message)
                        }
                        getAllDocuments();
                        onHide();
                    } else {
                        toast.error("Oops..Something went wrong!!");
                    }
                } else {
                    toast.error("Folder is not in trash");
                }
            } else {
                toast.error("Error fetching document information");
            }
        } catch (error) {
            console.error("Error permanently deleting folder:", error.message);
            toast.error("Oops..Something went wrong!!");
        }
    };

    return (
        <>
            <Loader loading={loading} />
            <Dialog 
                open={show}
                TransitionComponent={Transition}
                keepMounted
                onClose={onHide}
                className={classes.dialog}
            >
                <DialogContent className={classes.dialogContent}>
                    <Box className={classes.iconWrapper}>
                        <WarningIcon className={classes.warningIcon} />
                    </Box>
                    <Typography className={classes.dialogTitle}>
                        Delete Permanently?
                    </Typography>
                    <Typography className={classes.dialogText}>
                        This action cannot be undone. The folder will be permanently deleted from your account.
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.actionButtons}>
                    <MuiButton 
                        onClick={onHide}
                        color='primary' 
                        variant='outlined'
                        className={classes.cancelBtn}
                    >
                        Cancel
                    </MuiButton>
                    <MuiButton 
                        onClick={handlePermanentDelete}
                        color='error' 
                        variant='contained'
                        className={classes.confirmBtn}
                    >
                        Delete Permanently
                    </MuiButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

/////////////////      Download Functionality         /////////////////////////////////////

export const DownloadOptionModal = ({ show, onHide, id }) => {
    const [documentData, setDocumentData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getDocsById = async () => {
        try {
                const response = await documentService.getDocumentbyId(id);
                if (response.status === 200) {
                setDocumentData(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
      // Fetch data when the component mounts or 'id' changes
      if (id) {
        getDocsById();
      }
    }, [id]);

    const handleDocxDownload = async () => {
        // const contentState = convertFromRaw(JSON.parse(documentData.onlyDocumentContent));
        // const contentHTML = stateToHTML(contentState);

        const htmlString = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <title>${documentData.document.documentName}</title>
            <style>
        table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
        }
        th, td {
            padding: 5px;
            text-align: left;
        }
    </style>
        </head>
        <body>
            <h3>${documentData.document.documentName}</h3>
            <hr/>
            ${documentData.documentBody}
        </body>
        </html>`;

        console.log(htmlString,"heyhey")

        asBlob(htmlString).then(docx => {
            saveAs(docx, `${documentData.document.documentName}.docx`);
            onHide(); // Close the modal after the download
        });

        const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "downloadDoc",
          };
    
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
    };


    const downloadSinglePDF = async() => {



        // const parsedJson = documentData.onlyDocumentContent ? JSON.parse(documentData.onlyDocumentContent) : { blocks: [{ text: '' }] };
        // const description = parsedJson.blocks[0].text;

        const pdfContent = `
        <style>
        table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
        }
        th, td {
            padding: 5px;
            text-align: left;
        }
    </style>
    <div><h5>${documentData.document.documentName}</h5><p>${documentData.documentBody}</p></div>`;

        console.log(pdfContent,"hoyhoy")



        const element = document.createElement('div');
        element.innerHTML = pdfContent;

        html2pdf(element, {
            margin: 10,
            filename: `${documentData.document.documentName}.pdf`, // Set the filename to the document name
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        }).then((pdf) => {
            saveAs(pdf, `${documentData.document.documentName}.pdf`);
        });
        onHide();

        const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "downloadDoc",
          };
    
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
    };



    return (
        <>
    <Loader loading={loading} />
      <Modal show={show} onHide={onHide} centered id="downloadOptionModal">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Download Options
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <span>Download as...</span>
            <br /> <br />
            <Button
              variant="primary"
              className="inviteMember mr-3 pl-5 pr-5"
              onClick={downloadSinglePDF}
            >
              PDF
            </Button>
            <Button
              variant="primary"
              className="inviteMember pl-5 pr-5"
              onClick={handleDocxDownload}
            >
              Word
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      </>

    );
};


export const DownloadBlogOptionModal = ({ show, onHide, id }) => {
    const [documentData, setDocumentData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getDocsById = async () => {
        try {
                const response = await getBlogById(id);
                if (response.status === 200) {
                setDocumentData(response.data);
            } else {
                console.error("Error fetching data:", response.message);
            }
        } catch (error) {
            console.error("Error calling backend API:", error.message);
        }
    };

    useEffect(() => {
      // Fetch data when the component mounts or 'id' changes
      if (id) {
        getDocsById();
      }
    }, [id]);

    const handleDocxDownload = async () => {
        // const contentState = convertFromRaw(JSON.parse(documentData.onlyDocumentContent));
        // const contentHTML = stateToHTML(contentState);

        const htmlString = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <title>${documentData.documentName}</title>
            <style>
        table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
        }
        th, td {
            padding: 5px;
            text-align: left;
        }
    </style>
        </head>
        <body>
            <h3>${documentData.documentName}</h3>
            <hr/>
            ${documentData.onlyDocumentContent}
        </body>
        </html>`;

        console.log(htmlString,"heyhey")

        asBlob(htmlString).then(docx => {
            saveAs(docx, `${documentData.documentName}.docx`);
            onHide(); // Close the modal after the download
        });

        const data1 = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "downloadBlog",
          };
      
          const addLogs = await addUserLogs(data1);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
    };


    const downloadSinglePDF = async() => {



        // const parsedJson = documentData.onlyDocumentContent ? JSON.parse(documentData.onlyDocumentContent) : { blocks: [{ text: '' }] };
        // const description = parsedJson.blocks[0].text;

        const pdfContent = `
        <style>
        table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
        }
        th, td {
            padding: 5px;
            text-align: left;
        }
    </style>
    <div><h3>${documentData.documentName}</h3><hr/><p>${documentData.onlyDocumentContent}</p></div>`;

        console.log(pdfContent,"hoyhoy")



        const element = document.createElement('div');
        element.innerHTML = pdfContent;

        html2pdf(element, {
            margin: 10,
            filename: `${documentData.documentName}.pdf`, // Set the filename to the document name
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        }).then((pdf) => {
            saveAs(pdf, `${documentData.documentName}.pdf`);
        });
        onHide();

        const data1 = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "downloadBlog",
          };
      
          const addLogs = await addUserLogs(data1);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
    };



    return (
        <>
    <Loader loading={loading} />
      <Modal show={show} onHide={onHide} centered id="downloadOptionModal">
        <Modal.Header closeButton>
          <Modal.Title className='zzz' id="contained-modal-title-vcenter">
            Download Options
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <span className='zzz'>Download as...</span>
            <br /> <br />
            <Button
              variant="primary"
              className="inviteMember mr-3 pl-5 pr-5"
              onClick={downloadSinglePDF}
            >
              PDF
            </Button>
            <Button
              variant="primary"
              className="inviteMember pl-5 pr-5"
              onClick={handleDocxDownload}
            >
              Word
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      </>

    );
};




/////////////////      Permanent Delete All Documents         /////////////////////////////////////

export const PermanentDeleteAllModal = ({ show, onHide, ids, getAllDocuments }) => {
    const classes = useStyles();

    const handlePermanentDelete = async () => {
        try {
            const response = await documentService.permanentDeleteAllDocuments(ids);
            if (response.status === 200) {
                toast.success('Documents deleted successfully');
                const logData = {
                    userId:sessionStorage.getItem("userId"),
                    organizationId:sessionStorage.getItem("organizationId"),
                    actionType:"deleteDocPermanent"
                }
                const addLogs = await addUserLogs(logData)
                if (addLogs.status !== 200) {
                    toast.error(addLogs.message)
                }
                getAllDocuments();
                onHide();
            } else {
                toast.error("Oops..Something went wrong!!");
            }
        } catch (error) {
            toast.error("Oops..Something went wrong!!");
        }
    };

    return (
        <Dialog 
            open={show}
            TransitionComponent={Transition}
            keepMounted
            onClose={onHide}
            className={classes.dialog}
        >
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.iconWrapper}>
                    <WarningIcon className={classes.warningIcon} />
                </Box>
                <Typography className={classes.dialogTitle}>
                    Delete All Items?
                </Typography>
                <Typography className={classes.dialogText}>
                    This action cannot be undone. All selected documents and folders will be permanently deleted.
                </Typography>
            </DialogContent>
            <DialogActions className={classes.actionButtons}>
                <MuiButton 
                    onClick={onHide}
                    color='primary' 
                    variant='outlined'
                    className={classes.cancelBtn}
                >
                    Cancel
                </MuiButton>
                <MuiButton 
                    onClick={handlePermanentDelete}
                    color='error' 
                    variant='contained'
                    className={classes.confirmBtn}
                >
                    Delete Permanently
                </MuiButton>
            </DialogActions>
        </Dialog>
    );
};


/////////////////      Delete All 'My Documents'         /////////////////////////////////////




export const DeleteAllMyDocsModal = ({ show, onHide, ids, getAllDocuments }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const response = await documentService.permanentDeleteAllDocuments(ids);

      if (response.status === 200) {
        toast.success("Deleted successfully");
        getAllDocuments();
        onHide();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error deleting items");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogContent style={{ padding: "24px" }}>
        
        {/* Title */}
        <Typography style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "10px"
        }}>
          Delete all items?
        </Typography>

        {/* Description */}
        <Typography style={{
          fontSize: "14px",
          color: "#666",
          lineHeight: "1.5"
        }}>
          This will permanently delete selected documents and folders.
          This action cannot be undone.
        </Typography>

      </DialogContent>

      {/* Actions */}
      <DialogActions style={{
        padding: "16px 24px",
        justifyContent: "flex-end",
        gap: "10px"
      }}>
        <MuiButton
          onClick={onHide}
          variant="text"
          style={{
            textTransform: "none",
            color: "#555"
          }}
        >
          Cancel
        </MuiButton>

        <MuiButton
          onClick={handleDelete}
          disabled={deleting}
          variant="contained"
          style={{
            textTransform: "none",
            backgroundColor: "#d32f2f", // subtle red
            color: "#fff"
          }}
        >
          {deleting ? "Deleting..." : "Delete"}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};